@if (isLoading) {
  <div class="d-flex justify-content-center p-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
} @else {
  <optima-form-layout [layout]="formLayout" (formDataChange)="onUpdateLibrary()"></optima-form-layout>
}
